export enum Status {
  Waiting = "waiting",
  Paid = "paid",
  Active = "active",
  InActive = "inactive",
  Deleted = "deleted",
  Running = "running"
}
